import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Heart, ArrowRight } from 'lucide-react';

const IndividualTraining = () => {
  useEffect(() => {
    document.title = 'Bireysel Eğitimler ve Danışmanlık | akarma';
  }, []);

  const services = [
    {
      number: '01',
      title: 'İletişim ve İlişki Danışmanlığı',
      description: 'Kişiler arası iletişim becerilerini geliştirme, ilişki sorunlarını çözme ve sağlıklı ilişkiler kurma konularında profesyonel destek.'
    },
    {
      number: '02',
      title: 'Öğrenci Danışmanlığı',
      description: 'Öğrencilerin akademik başarılarını artırmak, sınav kaygısını azaltmak, motivasyon ve hedef belirleme konularında rehberlik.'
    },
    {
      number: '03',
      title: 'İlişkiler, İletişim ve Stressiz Yaşam',
      description: 'Yaşam dengesi kurma, stres yönetimi, sağlıklı iletişim kurma ve ilişkilerde uyum sağlama eğitimleri.'
    },
    {
      number: '04',
      title: 'NLP Teknikleri ile Fobi Çalışmaları',
      description: 'Fobiler, korkular ve travmaların NLP teknikleri kullanılarak hızlı ve etkili bir şekilde tedavi edilmesi.'
    },
    {
      number: '05',
      title: 'Bireysel Gelişim Danışmanlığı/Bireysel Koçluk',
      description: 'Kişisel hedeflere ulaşma, özgüven artırma, potansiyeli ortaya çıkarma ve yaşam kalitesini yükseltme konularında koçluk.'
    },
    {
      number: '06',
      title: 'Bireylere ve Çiftlere Danışmanlık',
      description: 'Çift terapisi, evlilik danışmanlığı, ilişki sorunları ve bireysel duygusal zorluklar için profesyonel destek.'
    }
  ];

  const approaches = [
    {
      title: 'Kuantum Sıçrama için Ayna Tekniği',
      description: 'Banu Gökcül tarafından geliştirilen, hızlı dönüşümsel iyileşme sağlayan çığır açan terapi tekniği.'
    },
    {
      title: 'NLP (Noro-Linguistik Programlama)',
      description: 'Bilinçaltı programlama, davranış değişimi ve kişisel dönüşüm için etkili teknikler.'
    },
    {
      title: 'Gestalt ve Psikodrama',
      description: 'Duygusal f arkındalık, geçmiş travmaların iyileştirilmesi ve şimdi ve burada odaklı terapi.'
    },
    {
      title: 'Hipnoz ve Bilinçaltı Telkinleri',
      description: 'Beyin frekans teknolojileri ile bilinçaltına ulaşma ve olumlu değişimleri teşvik etme.'
    }
  ];

  const issues = [
    'Ağrılar ve kronik rahatsızlıklar',
    'Korkular ve fobiler',
    'Kaygı bozuklukları',
    'Yetersizlik ve değersizlik duygusu',
    'Suçluluk ve utanma hissi',
    'Aşk acısı ve ilişki sorunları',
    'Panik atak',
    'Öfke yönetimi',
    'Motivasyon eksikliği',
    'Hedef belirleme ve ulaşma',
    'Stres ve tükenmişlik',
    'Özgüven eksikliği'
  ];

  return (
    <div className="individual-training pt-24 pb-20">
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-akarma-blue-700 to-akarma-blue text-white py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <Heart size={64} className="mx-auto mb-6" />
            <h1 className="text-5xl md:text-6xl font-bold mb-6 fade-in">Bireysel Eğitimler</h1>
            <p className="text-xl md:text-2xl opacity-90">
              Kişiye özel danışmanlık ve terapi hizmetleri
            </p>
          </div>
        </div>
      </section>

      {/* Intro */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <p className="text-xl text-gray-700 leading-relaxed mb-8">
              Banu Gökcül, 20 yılı aşkın mentorluk ve terapi deneyimi ile ulusal ve uluslararası 
              sinema ve tiyatro oyuncuları, CEO'lar, ünlü sporcular ve binlerce kişinin derin kişisel 
              sorunlarının üstesinden gelmesine yardımcı olmuştur.
            </p>
            <div className="bg-gradient-to-r from-akarma-blue-700 to-akarma-blue text-white p-6 rounded-xl">
              <p className="text-2xl font-semibold">
                "Tüm 'konu'larınızı garanti vererek çözümlemenizi sağlamaktayız."
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Services */}
      <section className="pb-20">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-4xl font-bold mb-12 text-center section-title">Danışmanlık Hizmetlerimiz</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {services.map((service, index) => (
                <div key={index} className="bg-white p-8 rounded-2xl shadow-lg card-hover">
                  <div className="text-5xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-akarma-blue-700 to-akarma-blue mb-4">
                    {service.number}
                  </div>
                  <h3 className="text-xl font-bold mb-4 text-gray-900">{service.title}</h3>
                  <p className="text-gray-600 leading-relaxed">{service.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Approaches */}
      <section className="py-20 bg-gradient-to-br from-purple-50 to-blue-50">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-4xl font-bold mb-12 text-center section-title">Kullanılan Yöntemler</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {approaches.map((approach, index) => (
                <div key={index} className="bg-white p-8 rounded-xl shadow-lg">
                  <h3 className="text-2xl font-bold mb-4 text-transparent bg-clip-text bg-gradient-to-r from-akarma-blue-700 to-akarma-blue">
                    {approach.title}
                  </h3>
                  <p className="text-gray-700 leading-relaxed">{approach.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Issues Addressed */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-4xl font-bold mb-12 text-center section-title">Çözüm Sağlanan Konular</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              {issues.map((issue, index) => (
                <div key={index} className="flex items-center space-x-3 bg-white p-4 rounded-xl shadow-md card-hover">
                  <div className="w-8 h-8 bg-gradient-to-br from-akarma-blue-700 to-akarma-blue rounded-lg flex items-center justify-center flex-shrink-0">
                    <span className="text-white font-bold">✓</span>
                  </div>
                  <span className="text-gray-700 font-medium">{issue}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Process */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-4xl font-bold mb-12 text-center section-title">Danışmanlık Süreci</h2>
            <div className="space-y-6">
              <div className="bg-white p-6 rounded-xl shadow-md flex items-start space-x-4">
                <div className="w-12 h-12 bg-gradient-to-br from-akarma-blue-700 to-akarma-blue rounded-full flex items-center justify-center flex-shrink-0 text-white font-bold text-xl">
                  1
                </div>
                <div>
                  <h3 className="text-xl font-bold mb-2">İlk Görüşme</h3>
                  <p className="text-gray-700">Durumunuzun değerlendirilmesi ve ihtiyaçlarınızın belirlenmesi.</p>
                </div>
              </div>
              <div className="bg-white p-6 rounded-xl shadow-md flex items-start space-x-4">
                <div className="w-12 h-12 bg-gradient-to-br from-akarma-blue-700 to-akarma-blue rounded-full flex items-center justify-center flex-shrink-0 text-white font-bold text-xl">
                  2
                </div>
                <div>
                  <h3 className="text-xl font-bold mb-2">Kişiye Özel Plan</h3>
                  <p className="text-gray-700">Size özel terapi ve koçluk planının oluşturulması.</p>
                </div>
              </div>
              <div className="bg-white p-6 rounded-xl shadow-md flex items-start space-x-4">
                <div className="w-12 h-12 bg-gradient-to-br from-akarma-blue-700 to-akarma-blue rounded-full flex items-center justify-center flex-shrink-0 text-white font-bold text-xl">
                  3
                </div>
                <div>
                  <h3 className="text-xl font-bold mb-2">Terapi Seansları</h3>
                  <p className="text-gray-700">Düzenli seanslar ile derin çalışma ve dönüşüm süreci.</p>
                </div>
              </div>
              <div className="bg-white p-6 rounded-xl shadow-md flex items-start space-x-4">
                <div className="w-12 h-12 bg-gradient-to-br from-akarma-blue-700 to-akarma-blue rounded-full flex items-center justify-center flex-shrink-0 text-white font-bold text-xl">
                  4
                </div>
                <div>
                  <h3 className="text-xl font-bold mb-2">Takip ve Destek</h3>
                  <p className="text-gray-700">Süreç sonrası destek ve gerektiğinde ek seanslar.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-4xl font-bold mb-6">Bireysel Danışmanlık Randevusu Alın</h2>
            <p className="text-xl text-gray-600 mb-8">
              Kendinize yatırım yapın ve yaşam kalitenizi artırın. 
              Randevu almak için bizimle iletişime geçin.
            </p>
            <Link
              to="/iletisim"
              className="inline-flex items-center px-8 py-4 bg-gradient-to-r from-akarma-blue-700 to-akarma-blue text-white rounded-full font-semibold hover:shadow-lg transition-all duration-300 text-lg"
            >
              Randevu Al
              <ArrowRight size={24} className="ml-2" />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default IndividualTraining;